import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../creds';
// import SpeakButton from './SpeakButton';

const slugify = (title) => {
  return title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
};

const openNews = (title) => slugify(title);

const NewsCard = ({ id, title, content, photo_url, date, isFeatured = true }) => {
  return (
    <Link
    to={`/news/${id}-${openNews(title)}`}
      className="border border-gray-200 rounded-lg overflow-hidden shadow-sm flex flex-col md:flex-row"
    >
      {photo_url ? (
        <img
          src={`${API_BASE_URL}/images/${photo_url}`}
          alt={title}
          className={`w-full md:w-1/3 ${isFeatured ? 'w-1/3 h-[85%]' : 'w-full'}`}
        />
      ) : (
        <div
          className={`${isFeatured ? 'w-1/3' : 'w-full'} bg-gray-200 flex items-center justify-center`}
        >
          <span className="text-gray-500">No Image</span>
        </div>
      )}
      <div className={`w-full p-4 ${isFeatured ? 'w-2/3' : 'flex-1'} flex flex-col`}>
        <h3
          className={`font-semibold leading-[1.1] text-gray-800 hover:text-blue-500 ${isFeatured ? 'text-2xl' : 'text-lg'}`}
        >
          {title || 'Untitled'}
        </h3>
        <p className="text-gray-600 mt-2 leading-[1.1] line-clamp-3 flex-1 text-xl text-justify">
          {content || 'No content available'}
        </p>
        <div className="flex flex-wrap justify-between mt-2">
          <div className="text-sm text-gray-500">
            <span>
              {date
                ? new Date(date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                  })
                : 'Unknown date'}
            </span>
          </div>
          {/* <div>
            <SpeakButton text={`${title}\n${content}`.toString()} />
          </div> */}
        </div>
      </div>
    </Link>
  );
};

NewsCard.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
  photo_url: PropTypes.string,
  source: PropTypes.string,
  isFeatured: PropTypes.bool,
};

export default NewsCard;